import {createContext} from 'react';

import {TDDFilterExpression} from 'features/predicate-expression-form-list';

export interface IReportDdFilterRulesContextArgs {
    childReportTemplateCode: string | null | undefined;
    filterInitialExpression: TDDFilterExpression | undefined;
}

export const ReportDdFilterRulesContext = createContext<IReportDdFilterRulesContextArgs>({
    childReportTemplateCode: undefined,
    filterInitialExpression: undefined,
});
